package one.healthium.onboarding.domain.configs

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.common.TextStyle
import one.healthium.onboarding.domain.models.HighlightItem

@Serializable
@SerialName("transparency_access")
data class TransparencyAccessScreenConfig(
    @SerialName("title") val title: String? = null,
    @SerialName("subtitle") val subtitle: String? = null,
    @SerialName("benefits_title") val benefitsTitle: String? = null,
    @SerialName("cta_title") val ctaTitle: String? = null,
    @SerialName("text_label") val textLabel: TextStyle? = null,
    @SerialName("benefits_title_label") val benefitsTitleLabel: TextStyle? = null,
    @SerialName("emoji_height") val emojiHeight: Int? = null,
    @SerialName("items") val items: List<HighlightItem> = emptyList(),
) : ScreenConfig